var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"items"},_vm._l((_vm.items),function(item,index){return _c('button',{key:index,staticClass:"item",class:{ 'is-selected': index === _setup.selectedIndex },on:{"click":function($event){return _setup.selectItem(index)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }